import React, { useContext, useEffect, useState } from "react";
import MyContext from "../../MyContext";
import ItemMaster from "../../../API/API_SERVISES/ItemMaster";
import LoyaltyMaster from "../../../API/API_SERVISES/LoyaltyMaster";
import CouponMasterApi from "../../../API/API_SERVISES/CouponMaster";
import MembershipCard from "./MembershipCard";

const BillDetailCard = (props) => {
  const {
    companyData,
    AppliedCouponData,
    totalDiscountAmt,
    totalPrice,
    InputValues,
    totalDiscountAmtWithoutDiscount,
    MembershipItems,
    AddMembershipToCart,
    isMembershipCardAdded,
    setMembershipItems,
    AutoApplyCoupon,
    // AutoApplyCouponType,
    // setAutoApplyCouponType,
    setIsMembershipCardAdded,
    setAutoApplyCoupon,
    setAllCouponsData,
    AllCouponsData,
    isMembershipDetails,
    setIsMembershipDetails,
    setLoading
  } = useContext(MyContext);

  // const [membershipItem, setMembershipItem] = useState({});

  useEffect(() => {
    if (isMembershipDetails && isMembershipDetails == 0) {
      var MembershipDetailsSring = localStorage.getItem("MembershipDetails"); // This is a string
      var MembershipDetails = JSON.parse(MembershipDetailsSring);
      if (MembershipDetails) {
        setIsMembershipDetails(MembershipDetails);
      }
    }
  }, []);

  useEffect(() => {
    console.log("AutoApplyCoupon", AutoApplyCoupon);
  }, [AutoApplyCoupon]);

  useEffect(() => {
    const GetmembershipItem = async () => {
      const filteredata = [
        {
          fieldName: "productCategory",
          operatorName: "equal",
          compareValue: 3,
        },
      ];
      var Item = await ItemMaster.GetItemMasterFilter(filteredata);
      if (Item && Item.length > 0) {
        setMembershipItems(Item);
      }
    };
    // debugger
    if (MembershipItems.length == 0) {
      GetmembershipItem();
    }
  }, []);
  useEffect(() => {
    const GetData = async () => {
      // debugger;
      // if (AutoApplyCoupon.length == 0) {
        setLoading(true)
      if (MembershipItems && MembershipItems.length > 0) {
        MembershipItems.forEach(async (IsmembershipinCartDetail, index) => {
          var membershipDetails =
            await LoyaltyMaster.GetLoyaltyMemberShipAccountCardDetail(
              IsmembershipinCartDetail.iUseMembershipCard
            );
          if (membershipDetails) {
            var AllCoupondata;
            if (AllCouponsData || AllCouponsData.length == 0) {
              AllCoupondata = await CouponMasterApi.getCouponMaster();
              setAllCouponsData(AllCoupondata);
            } else {
              AllCoupondata = AllCouponsData;
            }
            var CouponData1 = AllCoupondata.filter((item) =>
              membershipDetails.autoApplyCouponsList.includes(item.id)
          );

          if(CouponData1[index]?.minPurchaseReqValue > totalDiscountAmtWithoutDiscount){
            setLoading(false)
            return
          } 
            // debugger;
            setAutoApplyCoupon((prevState) => {
              const isAlreadyAdded = prevState.some(
                (coupon) => coupon.CardId === IsmembershipinCartDetail?.d2Id
              );
              if (isAlreadyAdded) return prevState;
              return [
                ...prevState,
                {
                  disVal: CouponData1[index]?.discountValue,
                  disType: CouponData1[index]?.discountType,
                  CardId: IsmembershipinCartDetail?.d2Id,
                },
              ];
            });
            setLoading(false)
          }
          else{
            setLoading(false)
          }
        });
        // }
      }else{
        setLoading(false)
      }
    };

    GetData();
  }, [MembershipItems , totalDiscountAmtWithoutDiscount]);

 

  return (<>
    <div
      className="cartpage-pricebox"
      style={{
        paddingBottom: "7px",
        paddingTop: "10px",
        width: props.width || "90%",
      }}
    >
      <div className="pricebox-type-1">
        <div className="pricebox-heading">Item Total</div>
        <div className="pricebox-heading-2">
          {companyData.currencySymbol} {totalDiscountAmtWithoutDiscount}
        </div>
      </div>
      <div style={{ color: "rgb(17, 186, 216)" }} className="pricebox-type-1">
        <div className="pricebox-heading">Total discount</div>
        <div className="pricebox-heading-2">
          <p
            style={{
              margin: "0",
              paddingLeft: "10px",
              width: "100%",
            }}
          >
            Flat &nbsp;
            {totalDiscountAmt || 0}
            {companyData.currencySymbol}
          </p>
        </div>
      </div>
      <div className="pricebox-type-1">
        <div className="pricebox-heading">Net Amount</div>
        <div className="pricebox-heading-2">
          {companyData.currencySymbol} {totalPrice}
        </div>
      </div>
      <div
        // style={{
          //   borderBottom: isMembershipCardAdded
        //     ? "0"
        //     : "1px dashed rgb(179, 179, 179)",
        // }}
        style={{
          borderBottom: "none",
        }}
        className="pricebox-type-1"
      >
        <div className="pricebox-heading Total-bold-pay">
          Total Payable (incl. Taxes)
        </div>
        <div className="pricebox-heading-2 Total-bold-pay">
          {companyData.currencySymbol} {totalPrice}
        </div>
      </div>
    </div>
      <MembershipCard />
        </>
  );
};

export default BillDetailCard;
